import React, { useState, useEffect } from 'react';
import classes from './LocationPage.module.scss';
import { Tabs, Tab } from 'react-bootstrap';
import useLocation from '@/hooks/useLocation';
import AutoComplete from '@/features/googleMap/components/GoogleLocation/AutoComplete';
import GoogleLocation from '@/features/googleMap/components/GoogleLocation/GoogleLocation';

const LocationPage = ({ answers, locationObject, saveLocationFn, showErrorMessage, ...props }) => {
  const autoCompleteElementId = 'allhomes-location-search-autocomplete';
  const t = props.t;
  const [currentTab, setCurrentTab] = useState('use-location');
  const { locationContext } = useLocation();
  const saveLocation = saveLocationFn || locationContext.updateLocationByPlace;

  useEffect(() => {
    const element = document.getElementById(autoCompleteElementId);
    if (element) {
      element.autocomplete = 'off';
    }
  }, [currentTab]);

  return (
    <>
      <div>
        <div className={classes.locationPage}>
          <Tabs id="controlled-tab-example" className={`${classes.tabLink} 'mb-3'`} onSelect={(key) => setCurrentTab(key)}>
            <Tab eventKey="use-location" title={t('Use location')} tabClassName={`${currentTab === 'use-location' ? classes.activeTab : ''}`}>
              {currentTab === 'use-location' && (
                <div className={classes.useLocation}>
                  <h5 className={classes.locationTitle}>{t('Address or city or zip code')}</h5>
                  <AutoComplete
                    elementId={autoCompleteElementId}
                    locationObject={locationObject}
                    saveLocationFn={saveLocation}
                    showFindLocation={true}
                    error={showErrorMessage}
                    additionalClasses={classes.findLocationLink}
                  />
                  {showErrorMessage && (
                    <span className={classes.locationErrorMessage}>
                      {t('Please enter a more specific location. Try entering an address, city, or zip code.')}
                    </span>
                  )}
                </div>
              )}
            </Tab>
            <Tab eventKey="use-map" title={t('Use map')} tabClassName={`${currentTab === 'use-map' ? classes.activeTab : ''}`}>
              {currentTab === 'use-map' && (
                <div className={classes.useMap}>
                  <h5 className={classes.locationTitle}>{t('Click or tap on an area on the map to select')}</h5>
                  <GoogleLocation
                    additionalClasses={classes.findLocationLink}
                    lat={locationContext.getLocation()?.lat}
                    lng={locationContext.getLocation()?.lng}
                    answerType={'location'}
                    onClick={(answerType, locationData) => saveLocation(locationData)}
                    answers={answers}
                    showMap={true}
                    locationObject={locationObject}
                    saveLocationFn={saveLocation}
                    showFindLocation={true}
                    autocomplete="top"
                    zoom={9}
                    findLocationLinkClass={classes.findLocationLinkClass}
                  />
                </div>
              )}
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default LocationPage;
